import { comments } from '@/mocks/homeData';

export default function Comments() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-100/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            吃瓜热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto">
            千万吃瓜群众的真实声音，看看大家都在讨论什么网红大瓜
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="flex flex-col gap-4 p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center text-sm font-bold font-heading shrink-0">
                  {comment.avatar}
                </div>
                <div className="flex flex-col gap-0.5 min-w-0">
                  <span className="text-sm font-semibold text-foreground-900 font-heading">
                    {comment.user}
                  </span>
                  <span className="text-xs text-foreground-400 font-label">{comment.time}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 font-body leading-relaxed">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 mt-auto pt-2 border-t border-background-100">
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400 font-label cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-thumb-up-line text-sm"></i> {comment.likes.toLocaleString()}
                </span>
                <span className="inline-flex items-center gap-1 text-xs text-foreground-400 font-label cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-3-line text-sm"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}